var defaultStyles = {
  "password": "Base-InputPassword--Password",
  "disabled": "Base-InputPassword--Disabled",
  "input_group_suffix": "Base-InputPassword--InputGroupSuffix"
};

export { defaultStyles as default };
